import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import WebHttpClient from '~src/httpClient/WebHttpClient';

import {
  FETCH_RESOURCE_ACTIONS_REQUEST,
  fetchResourceActionsFailure,
  fetchResourceActionsSuccess} from '../actions/ResourceActions';
import {
  GetAllowedResourceActionsForActorRequest,
  IResourceActionsResult
} from '../serverApi/requests/GetAllowedResourceActionsForActorRequest';

function* handleFetchResourceActions(): SagaIterator {
  try {
    const result: IResourceActionsResult = yield call(
      [WebHttpClient, WebHttpClient.sendRequest],
      new GetAllowedResourceActionsForActorRequest()
    );

    yield put(fetchResourceActionsSuccess(result.resourceActions));
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch resource actions';
    yield put(fetchResourceActionsFailure(errorMessage));
    yield put(requestFailed(error, errorMessage));
  }
}

export function* rootResourceActionsSaga(): SagaIterator {
  yield takeLatest(FETCH_RESOURCE_ACTIONS_REQUEST, handleFetchResourceActions);
}
